import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { NkDatatableAbstractColumnComponent } from '@nk/ui-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

function isArrayOfStrings(item: unknown): item is string[] {
  return Array.isArray(item) && item.every((i) => typeof i === 'string');
}

@Component({
  selector: 'nk-company-role-keys-column',
  imports: [NgIf, AsyncPipe, TranslateModule],
  templateUrl: './company-role-keys-column.component.html',
  styleUrls: ['./company-role-keys-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TranslatePipe],
})
export class CompanyRoleKeysColumnComponent<T> extends NkDatatableAbstractColumnComponent<T> {
  public companyRoleKeys$: Observable<string> = this.value$.pipe(
    map((value) => {
      if (value && value.row && value.prop) {
        const item = value.row && value.row[value.prop];
        if (isArrayOfStrings(item) && item.length) {
          return item.map((i) => this._translatePipe.transform(`company_role.${i}`) as string).join(', ');
        }
      }
      return '-';
    }),
  );

  constructor(private _translatePipe: TranslatePipe) {
    super();
  }
}
